// extracted by mini-css-extract-plugin
export var errorMessage = "SingleInputForm-module--errorMessage--b1d24";
export var errorMode = "SingleInputForm-module--errorMode--ce6bc";
export var feedbackContainer = "SingleInputForm-module--feedbackContainer--21d12";
export var form = "SingleInputForm-module--form--83266";
export var formWrapper = "SingleInputForm-module--formWrapper--ec196";
export var giftCardId = "SingleInputForm-module--giftCardId--4617f";
export var input = "SingleInputForm-module--input--ebb36";
export var inputButton = "SingleInputForm-module--inputButton--948ee";
export var inputFieldContainer = "SingleInputForm-module--inputFieldContainer--ac9ca";
export var loadIcon = "SingleInputForm-module--loadIcon--bee30";
export var resultIcon = "SingleInputForm-module--resultIcon--92e1a";